exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DataLoadStatusPanel{position:absolute;top:50px;right:0;z-index:150;border-style:solid;border-width:2px;background:#fff;margin:2px;padding:5px}.DataLoadStatusPanel img{width:20px;height:20px;margin:1px}.DataLoadStatusPanel span.Error{color:red}.DataLoadStatusPanel span{margin:2px}", ""]);

// exports
